import { Box, Tab, Tabs } from '@mui/material'
import type { ChangeEvent, JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { layoutStyles, theme } from '@/utils/theme'

export default function DeviceInfoPage(): JSX.Element {
  const [t] = useTranslation('app')
  const navigate = useNavigate()
  const { uid } = useParams<{ uid: string }>()
  const currentTab = location.pathname.split('/').pop() ?? 'device'

  const handleTabChange = (event: ChangeEvent<unknown>, newValue: number) => {
    const tabRoutes = ['info', 'reports', 'fota']
    navigate(`/v2/main/device/${uid}/${tabRoutes[newValue]}`)
  }

  const getTabValue = () => {
    const tabRoutes = ['info', 'reports', 'fota']
    const index = tabRoutes.indexOf(currentTab)
    return index === -1 ? 0 : index
  }

  return (
    <Box
      sx={{
        ...layoutStyles.pageContainer,
        mt: 0,
        p: 2,
      }}
      id={'device info box'}
    >
      <Box sx={{ ...layoutStyles.tabsContainer }} id={'tab container box'}>
        <Tabs
          value={getTabValue()}
          onChange={handleTabChange}
          aria-label="device info tabs"
          variant="standard"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.secondary.main,
              height: 3,
            },
            '& .MuiTabs-flexContainer': {
              justifyContent: 'flex-start',
            },
            mb: 2,
          }}
        >
          <Tab
            label={t('common:tabs.device')}
            id={`tab-0`}
            aria-controls={`tabpanel-0`}
            sx={{
              fontSize: '0.875rem',
              fontWeight: 400,
              width: '160px',
              maxWidth: '264px',
              minWidth: '72px',
              textTransform: 'uppercase',
              '&.Mui-selected': {
                color: theme.palette.text.primary,
              },
            }}
          />
          <Tab
            label={t('common:tabs.reports')}
            id={`tab-0`}
            aria-controls={`tabpanel-0`}
            sx={{
              fontSize: '0.875rem',
              fontWeight: 400,
              width: '160px',
              maxWidth: '264px',
              minWidth: '72px',
              textTransform: 'uppercase',
              '&.Mui-selected': {
                color: theme.palette.text.primary,
              },
            }}
          />
          <Tab
            label={t('common:tabs.fota')}
            id={`tab-0`}
            aria-controls={`tabpanel-0`}
            sx={{
              fontSize: '0.875rem',
              fontWeight: 400,
              width: '160px',
              maxWidth: '264px',
              minWidth: '72px',
              textTransform: 'uppercase',
              '&.Mui-selected': {
                color: theme.palette.text.primary,
              },
            }}
          />
        </Tabs>
        <Outlet />
      </Box>
    </Box>
  )
}
